// extracted by mini-css-extract-plugin
module.exports = {"invoiceExportSelect":"InvoiceExportLanguage_invoiceExportSelect__hvmcO"};